/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { booleanAttribute, Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ods-user-icon',
  imports: [IconComponent],
  template: `@if (isNotFound) {
      <ods-icon name="error" [config]="{ fill: 'error', size: 'large' }" data-test-class="user-profile-not-found" />
    } @else if (initials) {
      <div class="bg-user-icon flex size-8 items-center justify-center rounded-full">
        <span class="text-whitetext text-sm font-semibold select-none" aria-hidden="true" data-test-class="user-profile-assigned">
          {{ initials }}
        </span>
      </div>
    } @else if (!initials) {
      <ods-icon name="user" [config]="{ fill: 'neutral', size: 'large' }" data-test-class="user-profile-unassigned" />
    }`,
  host: { class: 'inline-block', role: 'img', '[attr.aria-label]': 'ariaLabel' },
})
export class UserIconComponent {
  @Input() initials: string;
  @Input({ transform: booleanAttribute }) isNotFound: boolean;
  @Input({ required: true }) ariaLabel: string;
}
